import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { useNavigate, useParams } from "react-router-dom";
import { get, uri } from "helpers/api_helper";
import * as api from "../../constants/api_constants";
import secureLocalStorage from "react-secure-storage";
import Footer from "components/VerticalLayout/Footer";
import DragAndDropComponent from "components/FileUploadDrag/DragAndDrop";
import { showErrorToast } from "helpers/toastMessages";

const ViewTimeSheet = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [weekEntries, setWeekEntries] = useState({});
  const [timeSheetData, setTimeSheetData] = useState(null);
  const [projects, setProjects] = useState([]);
  console.log("projects", projects);

  const [assignments, setAssignments] = useState([]);
  const navigate = useNavigate();
  const { timeSheetId } = useParams();
  const employeeId = secureLocalStorage.getItem("employeeId");
  const [timesheetFiles, setTimesheetFiles] = useState({});

  // console.log("timeSheetData",timeSheetData);

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch timesheet data first

        const timesheetResponse = await get(
          api.GET_TIMESHEET_BY_ID(timeSheetId)
        );
        // console.log("timesheetResponse",timesheetResponse);
        
        // const timesheetDoc= timesheetResponse.clientDocuments;
        // console.log(timesheetDoc);

        const timesheetDoc = Array.isArray(timesheetResponse.clientDocuments)
          ? timesheetResponse.clientDocuments
          : timesheetResponse.clientDocuments
          ? [timesheetResponse.clientDocuments] // Wrap single string in an array
          : [];

        const fileDetails = await Promise.all(
          timesheetDoc.map(async (fileId) => {
            try {
              const fileResponse = await get(
                `${uri}/fileservice/api/files/view/${fileId}`
              );
              return {
                id: fileResponse.id,
                fileName: fileResponse.fileName,
                name: fileResponse.fileName, // Match AddProject's structure
                path: fileResponse.path || `/uploads/${fileResponse.fileName}`,
              };
            } catch (error) {
              console.error(`Error fetching file ${fileId}:`, error);
              return null;
            }
          })
        );
        setTimesheetFiles(fileDetails.filter((file) => file !== null));
        // console.log("ass", assignmentDocuments);

        setTimeSheetData(timesheetResponse);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (timeSheetId) {
      fetchData();
    }
  }, [timeSheetId]);

  const fetchProjectsData = async () => {
    try {
      const response = await get(api.GET_ALL_PROJECTS_ID_NAMES);
      console.log("response", response);

      const updatedProjects = response?.paginationResponse?.data.map(
        (item) => ({
          id: item.projectId,
          value: item.projectId,
          name: `${item.projectName} - (${item.projectCode})`,
        })
      );
      console.log("updatedProjects", updatedProjects);

      setProjects(updatedProjects);
    } catch (error) {
      showErrorToast("Fetching projects failed");
    }
  };

  const fetchAssignmentsData = async () => {
    try {
      const response = await get(api.GET_ALL_ASSIGNMENTS_ID_NAME);
      console.log("response", response);
      const updatedAssignments = response?.data?.map((item) => ({
        id: item.assignmentId,
        value: item.assignmentId,
        name: `${item.assignmentTitle} - (${item.assignmentCode})`,
      }));
      setAssignments(updatedAssignments);
    } catch (error) {
      showErrorToast("Fetching assignments failed");
    }
  };

  useEffect(() => {
    fetchProjectsData();
    fetchAssignmentsData();
  }, []);
  // Generate calendar days for the week
  const generateCalendarDays = (startDate) => {
    const days = [];
    const date = new Date(startDate);
    date.setDate(date.getDate() - date.getDay()); // Start from Sunday
    for (let i = 0; i < 7; i++) {
      const currentDate = new Date(date);
      currentDate.setDate(date.getDate() + i);
      days.push({
        date: currentDate,
        dayName: currentDate.toLocaleDateString("en-US", { weekday: "long" }),
        formattedDate: currentDate.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        }),
        isWeekend: currentDate.getDay() === 0 || currentDate.getDay() === 6,
      });
    }
    return days;
  };

  // Populate week entries when timesheet data is loaded
  useEffect(() => {
    if (timeSheetData) {
      // Populate selected date based on period start
      const periodStartDate = new Date(timeSheetData.periodStart);
      setSelectedDate(periodStartDate);

      // Generate calendar days for the selected week
      const weekDays = generateCalendarDays(periodStartDate);

      // Prepare week entries from existing timesheet data
      const newEntries = {};
      weekDays.forEach((day) => {
        const dayName = day.dayName.toLowerCase();
        const currentDate = day.date.toISOString().split("T")[0];

        // Check if there's an existing entry for this date
        const existingEntry = timeSheetData.dailyHours[currentDate] || {
          hours: day.isWeekend ? "0" : "8",
          description: "",
        };

        newEntries[dayName] = {
          hours: existingEntry.hours.toString(),
          description: existingEntry.description || "",
          date: currentDate,
        };
      });

      setWeekEntries(newEntries);
    }
  }, [timeSheetData]);

  // Calculate total hours for the week
  const getWeekTotal = () => {
    return Object.values(weekEntries)
      .reduce((total, day) => total + (parseFloat(day.hours) || 0), 0)
      .toFixed(2);
  };

  // Find selected project name
  // debugger
  const getSelectedProjectName = () => {
    const project = projects.find((p) => p.value === timeSheetData?.projectId);
    console.log("project", project);

    return project ? project.name : "N/A";
  };

  // Find selected assignment name
  const getSelectedAssignmentName = () => {
    const assignment = assignments.find(
      (a) => a.value === timeSheetData?.assignmentId
    );
    return assignment ? assignment.name : "N/A";
  };

  // Render component
  return (
    <div className="page-content">
      <Container fluid className="py-0 px-0">
        <PageSubHeader
          heading="View Timesheet"
          routePath="Home"
          pageName="Timesheet"
        />

        <Row className="p-4">
          <Col>
            <Card>
              <CardBody>
                <Form>
                  <Row className="mb-4 g-3">
                    <Col md="4">
                      <FormGroup>
                        <Label className="fw-bold">Select Week</Label>
                        <DatePicker
                          selected={selectedDate}
                          dateFormat="MM/dd/yyyy"
                          className="form-control"
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label className="fw-bold">Project</Label>
                        <Input
                          type="text"
                          value={getSelectedProjectName()}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label className="fw-bold">Assignment</Label>
                        <Input
                          type="text"
                          value={getSelectedAssignmentName()}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {timeSheetId &&
                    timeSheetData?.status === "REJECTED" &&
                    timeSheetData?.rejectionReason && (
                      <Row className="mb-4">
                        <Col>
                          <Card className="border-danger">
                            <CardBody>
                              <p className="mb-0 text-danger fw-bold">
                                Rejection Reason:{" "}
                                <span className="fw-normal text-dark px-2">
                                  {timeSheetData.rejectionReason}
                                </span>
                              </p>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    )}

                  <div className="table-responsive">
                    <Table bordered hover className="border shadow-sm">
                      <thead className="bg-light">
                        <tr>
                          <th style={{ width: "20%" }}>Day</th>
                          <th style={{ width: "20%" }}>Hours</th>
                          <th style={{ width: "60%" }}>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {generateCalendarDays(selectedDate).map((day) => (
                          <tr key={day.dayName}>
                            <td className="align-middle">
                              <div className="fw-bold">{day.dayName}</div>
                              <div className="text-muted small">
                                {day.formattedDate}
                              </div>
                            </td>

                            <td>
                              <Input
                                type="text"
                                value={
                                  weekEntries[day.dayName.toLowerCase()]?.hours
                                }
                                className={`text-center ${
                                  day.isWeekend ? "bg-light" : ""
                                }`}
                                disabled
                              />
                            </td>
                            <td>
                              <Input
                                type="textarea"
                                rows="1"
                                value={
                                  weekEntries[day.dayName.toLowerCase()]
                                    ?.description
                                }
                                className={day.isWeekend ? "bg-light" : ""}
                                disabled
                              />
                            </td>
                          </tr>
                        ))}
                        <tr className="bg-light fw-bold">
                          <td colSpan="2" className="text-end">
                            Total Hours:
                          </td>
                          <td className="text-center">{getWeekTotal()}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                  {/* <Row className="card-group mt-3 flex">
                    <Col xs={12} className="card-header">
                      <p className="form-header">Cilent Documents</p>
                    </Col>
                   
                  </Row> */}
                  <Col md={3}>
                    {timesheetFiles.length > 0 ? (
                      timesheetFiles.map((doc) => (
                        <div
                          key={doc.id}
                          className="position-relative rounded py-2 pe-4 mb-3"
                        >
                          <DragAndDropComponent
                            initialFile={doc}
                            readOnly={true}
                          />
                        </div>
                      ))
                    ) : (
                      <p>No documents available.</p>
                    )}
                  </Col>

                  <Row className="mt-4">
                    <Col className="d-flex gap-2 justify-content-between">
                      <div className="d-flex align-items-center">
                        <Label className="me-3 fw-bold">
                          Timesheet Status:
                        </Label>
                        <span
                          className={`badge ${
                            timeSheetData?.status === "SUBMITTED"
                              ? "bg-warning" // Green for SUBMITTED
                              : timeSheetData?.status === "DRAFT"
                              ? "bg-secondary text-black" // Yellow for DRAFT
                              : timeSheetData?.status === "APPROVED"
                              ? "bg-primary" // Blue for APPROVED
                              : timeSheetData?.status === "REJECTED"
                              ? "bg-danger" // Red for REJECTED
                              : "bg-secondary" // Gray for unknown or N/A
                          }`}
                        >
                          {timeSheetData?.status || "N/A"}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Footer
          saveText="Edit TimeSheet"
          save={() => navigate(`/add-timesheet/${timeSheetId}`)}
          showBackConfirmation={false}
          showSave={timeSheetData?.status === "APPROVED" ? false : true}
        />
      </Container>
    </div>
  );
};

export default ViewTimeSheet;
